import { grey } from 'hfty-styles/src/colors'

const commonStyles = {
  label: {
    marginRight: '7px',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 0',
  },
  slider: {
    width: '100px',
  },
  selectWrapper: {
    position: 'relative',
    display: 'flex',
    marginRight: '10px',
    textAlign: 'left',
  },
  select: {
    width: '4em',
    height: '2em',
    textAlign: 'left',
  },
  controlsWrapper: {
    position: 'absolute',
    right: 0,
    width: '1em',
  },
  arrowWrapper: {
    height: '14px',
  },
  arrow: {
    position: 'absolute',
    cursor: 'pointer',
  },
  up: {
    top: '5px',
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderBottom: `5px solid ${grey()}`,
  },
  bottom: {
    bottom: '5px',
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '5px solid rgb(60, 60, 60)',
  },
}

export default commonStyles
